import React, { Component } from 'react';
import SoundRepository from '../../game/handlers/SoundRepository';
import LocalStorage from '../../local-storage/LocalStorage';
import MuteButton from '../../small-components/mute-button/MuteButton';
import PrevButton from '../../small-components/prev-button/PrevButton';
import './MyPlatePage.css';

class MyPlatePage extends Component {
    constructor(props) {
        super(props);

        this.soundRepository = SoundRepository;
        this.localStorage = LocalStorage.getAllStorage()
        this.levelPlate = this.definingLevelIcon(this.localStorage.score)
    }

    definingLevelIcon = (score) => {
        let plateSrc;
        switch (true) {
            case score < 300 && score > 0:
                plateSrc = "gray-plate"
                break;
            case score > 300:
                plateSrc = "gold-plate"
                break;

            default: plateSrc = "gray-plate"
                break;
        }

        return plateSrc;
    }

    render() {
        return (
            <div className="page">

                <MuteButton />
                <PrevButton pageProps={this.props} />

                <div className="my-record-plate">
                    <div className="my-plate-content">
                        <h1 className="my-plate-title">הצלחת שלי</h1>
                        <h1 content="name" >{this.localStorage.name}</h1>

                        <div className="my-plate-details">
                            <p content="schoolName">בית ספר: <span>{this.localStorage.schoolName}</span></p>
                            <p content="class">כיתה: <span>{this.localStorage.grade}</span></p>
                            <p content="score"><span>{this.localStorage.score}</span> :ניקוד</p>
                            
                            <div className="score-box">
                                <p className="detail-headLine"> :הרמה שלי</p>
                                <img className="plate-level" alt="plate_level" draggable="false" src={require(`../../media/images/icons/${this.levelPlate}.png`)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MyPlatePage;
